import React, { createContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ErrorContext = createContext(null);

export const ErrorProvider = ({ children }:any) => {
  const navigate = useNavigate();
  (window as any).handleNetworkError = () => {
    navigate('/no-internet');
  };
  
  useEffect(() => {
    // Глобальная переменная для хранения функции навигации
    
  }, []);

  return (
    <ErrorContext.Provider value={null}>
      {children}
    </ErrorContext.Provider>
  );
};